import type { IconSvgProps } from '../Icon.types';

export const ScalesSimple = ({ width, height }: IconSvgProps) => {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.5c.166 0 .325.066.442.183.117.117.183.276.183.442v1.719l4.865-1.082a.5.5 0 0 1 .573.342l2.5 6.25c.03.075.045.154.045.234 0 1.821-1.917 2.5-3.125 2.5-1.208 0-3.125-.679-3.125-2.5 0-.08.015-.16.045-.234l2.065-5.148-3.984.884V16.25h1.25a.625.625 0 1 1 0 1.25H8.125a.625.625 0 1 1 0-1.25h1.25V6.406L5.228 7.326l2.227 5.565c.03.074.045.154.045.234 0 1.821-1.917 2.5-3.125 2.5S1.25 14.946 1.25 13.125c0-.08.015-.16.045-.234l2.5-6.25v-.005a.5.5 0 0 1 .444-.321l5.136-1.142V3.125c0-.166.066-.325.183-.442A.621.621 0 0 1 10 2.5ZM4.375 8.558 2.505 13.23c.092.862 1.282 1.144 1.87 1.144.588 0 1.778-.282 1.87-1.144L4.375 8.558Zm11.25-2.5-1.87 4.674c.092.861 1.282 1.143 1.87 1.143.588 0 1.778-.282 1.87-1.143l-1.87-4.674Z"
      />
    </svg>
  );
};
